import React from 'react';
const About = () => {
  return (
    <div>
      <section
        id="colorlib-hero"
        className="js-fullheight"
        data-section="about"
      >
        <div className="flexslider js-fullheight">
          <ul className="slides">
            <li style={{ backgroundImage: 'url(images/idea2mac.jpg)'}}>
              <div className="overlay" />
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-7 col-md-offset-0 col-lg-3 slider-text">
                    <div className="slider-text-inner js-fullheight">
                      <img src="images/note2.png" alt="" width='200px'/>
                    </div>
                  </div>
                </div>
                
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default About;
